export const RETRIEVE_ABSENCES = 'absences/retrieve';
export const RETRIEVE_ABSENCE = 'absences/getById';
